import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categoria-permissao-listar',
  templateUrl: './categoria-permissao-listar.component.html',
  styleUrls: ['./categoria-permissao-listar.component.scss']
})
export class CategoriaPermissaoListarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
